/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
import React from "react";

const TermsPage = () => {
  return (
    <div className="min-h-screen relative overflow-hidden bg-penta-grey-light">
      <div className="container mx-auto py-24 px-4 relative z-20">
        <h1 className="text-3xl font-light text-center mb-8 text-penta-black">
          Terms & Conditions
        </h1>
        <div className="legaltext font-sans bg-penta-white p-8 border border-penta-grey-medium">
          {/* Apply styles to all child elements */}
          <style jsx>{`
            /* Container to center content */
            .legaltext {
              display: flex;
              flex-direction: column;
              align-items: center;
            }

            /* Apply to all direct children elements */
            .legaltext > * {
              max-width: 768px;
              width: 100%;
            }

            .legaltext h2 {
              font-size: 1.75rem;
              font-weight: 700;
              margin-top: 2rem;
              margin-bottom: 1rem;
              color: #333;
            }

            .legaltext h3 {
              font-weight: 600;
              margin-top: 1.75rem;
              margin-bottom: 0.75rem;
              color: #444;
            }

            .legaltext h4 {
              font-weight: 600;
              margin-top: 1.5rem;
              margin-bottom: 0.5rem;
              color: #555;
            }

            .legaltext p {
              font-size: 1rem;
              line-height: 1.6;
              margin-bottom: 1rem;
              color: #333;
            }

            .legaltext a {
              color: #3941eb;
              text-decoration: underline;
            }

            .legaltext a:hover {
              color: #00fba9;
            }
          `}</style>
          <h2>
            <strong>
              Pentatonic GmbH and its subsidiaries, Pentatonic Ltd and Infinitum
              Technologies Inc
            </strong>
          </h2>

          <h3>
            <strong>Preamble</strong>
          </h3>

          <p>
            The following Terms and Conditions govern your use of the Pentatonic
            website and digital platforms. These terms apply to all visitors,
            users, and others who access or use our website and digital
            services.
          </p>
          <h3>
            <strong>1. Scope</strong>
          </h3>

          <p>
            These Terms and Conditions apply to all interactions with the
            website and digital platforms of PENTATONIC GmbH and its
            subsidiaries, Pentatonic Ltd and Infinitum Technologies Inc
            (hereinafter referred to as "PENTATONIC"). By accessing or using our
            website, you agree to be bound by these Terms and Conditions. If not
            agreed explicitly otherwise, the version of the Terms and Conditions
            that applies is the one available at
            <a href="http://www.pentatonic.com">
              {" "}
              http://www.pentatonic.com
            </a>{" "}
            at the time of your visit.
          </p>
          <p>
            In ongoing business relationships, PENTATONIC may modify these terms
            with future effect, provided that the respective changes are
            reasonable for the user. Users will be informed about any
            modifications by email. In the event that the user does not object
            to those changes by sending an email within six weeks after receipt
            of the notification, such modifications are deemed to be accepted.
            PENTATONIC will inform the user about the right to object in the
            modification notice.
          </p>
          <h3>
            <strong>2. Website Content and Services</strong>
          </h3>

          <p>
            The PENTATONIC website provides information about our circular
            economy consulting services and AI-enabled product recycling,
            refilling, and reusing solutions for international corporate
            clients. Content on our website, including descriptions of our
            services, case studies, and resource materials, is provided for
            informational purposes only and does not constitute a binding offer
            to enter into an agreement but is an invitation to potential clients
            to initiate business discussions.
          </p>
          <p>
            Expressions of interest submitted through our website forms are not
            considered binding contracts. PENTATONIC may respond to inquiries
            within 5 working days to schedule consultations or provide
            additional information.
          </p>
          <h3>
            <strong>3. Communication</strong>
          </h3>

          <p>
            Users who submit inquiries or requests for information must provide
            a valid email address and ensure they are reachable at this address
            until their inquiry is addressed. Users may provide a different
            contact email by notifying PENTATONIC of the new address by email.
          </p>
          <p>
            PENTATONIC is entitled to use all communication channels that the
            user has provided for communications related to website inquiries
            unless a different form is required by law.
          </p>
          <h3>
            <strong>4. Intellectual Property Rights</strong>
          </h3>

          <p>
            All content on the PENTATONIC website, including but not limited to
            text, graphics, logos, images, audio clips, digital downloads, data
            compilations, software, and the compilation thereof, is the property
            of PENTATONIC or its content suppliers and is protected by
            international copyright and intellectual property laws.
          </p>
          <p>
            Users may view, download, and print content from the PENTATONIC
            website for their own personal and non-commercial use, provided they
            do not modify or delete any copyright, trademark, or other
            proprietary notices.
          </p>
          <p>
            Users may not reproduce, distribute, display, sell, lease, transmit,
            create derivative works from, translate, modify, reverse-engineer,
            disassemble, decompile, or otherwise exploit the PENTATONIC website
            or any portion of it without PENTATONIC's explicit written
            permission.
          </p>
          <h3>
            <strong>5. Digital Services and Agentic Search</strong>
          </h3>

          <h4>
            <strong>5.1 Scope and Description of Agentic Search</strong>
          </h4>

          <p>
            PENTATONIC offers an AI-powered agentic search service (hereinafter
            "Agentic Search") that actively interprets user queries,
            autonomously gathers information from various sources, and presents
            personalized results about our circular economy solutions and
            services.
          </p>
          <p>Agentic Search includes the following functionalities:</p>
          <p>a) Interpretation and refinement of user queries;</p>
          <p>b) Autonomous information gathering from multiple sources;</p>
          <p>
            c) Personalization of search results based on user preferences and
            past interactions;
          </p>
          <p>
            d) Proactive information suggestions that may be relevant to user
            needs related to circular economy and sustainability solutions.
          </p>
          <p>
            The scope of the service may be modified by PENTATONIC at any time
            to enhance functionality or comply with legal requirements. Users
            will be notified of substantive changes as outlined in Section 1.
          </p>
          <h4>
            <strong>5.2 User Rights and Responsibilities</strong>
          </h4>

          <p>
            <strong>Acceptable Use</strong>
          </p>
          <p>
            Users agree to use the Agentic Search service only for lawful
            purposes and in accordance with these Terms and Conditions.
          </p>
          <p>Users are prohibited from:</p>
          <p>
            a) Attempting to circumvent, disable, or otherwise interfere with
            security-related features of the service;
          </p>
          <p>
            b) Using the service to generate content that is illegal, harmful,
            threatening, abusive, harassing, tortious, defamatory, vulgar,
            obscene, or otherwise objectionable;
          </p>
          <p>
            c) Attempting to reverse-engineer or extract the underlying models,
            algorithms, or training data;
          </p>
          <p>
            d) Using automated systems or software to extract data from the
            service beyond what is necessary for personal use e) Overloading or
            flooding the service with excessive queries or requests f)
            Introducing malicious code or attempting to compromise the integrity
            of the service.
          </p>
          <p>
            Users are responsible for all queries submitted through their
            account and must ensure they comply with applicable laws and
            regulations.
          </p>
          <p>
            <strong>User Content and Queries</strong>
          </p>
          <p>
            Users retain ownership of the content of their search queries.
            However, by submitting queries to the Agentic Search service, users
            grant PENTATONIC a worldwide, non-exclusive, royalty-free license to
            use, reproduce, and analyze those queries for the purposes of:
          </p>
          <p>a) Providing and improving the service;</p>
          <p>b) Developing and training AI models;</p>
          <p>c) Ensuring compliance with these Terms and Conditions.</p>
          <p>
            PENTATONIC may anonymize and aggregate user queries for service
            improvement, analytics, and development purposes.
          </p>
          <h4>
            <strong>5.3 Warranties and Disclaimers</strong>
          </h4>

          <p>
            PENTATONIC provides the Agentic Search service on an "as is" and "as
            available" basis.
          </p>
          <p>
            While PENTATONIC strives for accuracy and quality, the nature of
            AI-powered search means that:
          </p>
          <p>a) Results may not always be complete or accurate;</p>
          <p>
            b) The service may occasionally generate incorrect, inappropriate,
            or irrelevant responses;
          </p>
          <p>
            c) The interpretation of queries and personalization of results
            involves automated decision-making that may not always align with
            user intent.
          </p>
          <p>PENTATONIC does not warrant that:</p>
          <p>a) The service will meet all user requirements;</p>
          <p>
            b) The service will be uninterrupted, timely, secure, or error-free;
          </p>
          <p>
            c) Results obtained through the service will be accurate, reliable,
            or meet user expectations.
          </p>
          <p>
            Users acknowledge that they use the information provided by the
            Agentic Search service at their own risk and should exercise
            judgment in relying on search results for important decisions.
          </p>
          <h3>
            <strong>6. Privacy and Data Protection</strong>
          </h3>

          <p>
            PENTATONIC's collection, processing, and use of personal data in
            connection with the website and digital services is governed by our
            Privacy Policy, which forms an integral part of these Terms and
            Conditions.
          </p>
          <p>Specific data rights related to website use include:</p>
          <p>a) The right to access and delete browsing history;</p>
          <p>b) The right to control personalization features;</p>
          <p>
            c) The right to opt out of having queries used for service
            improvement.
          </p>
          <p>
            PENTATONIC retains the right to use anonymized and aggregated data
            derived from user interactions with the website and digital services
            indefinitely for service improvement, research, and development
            purposes.
          </p>
          <h3>
            <strong>7. Limitation of Liability</strong>
          </h3>

          <p>
            Liability of PENTATONIC is excluded, irrespective of the legal
            basis, unless provided otherwise in the following paragraphs. The
            exclusion of liability does not apply:
          </p>
          <p>
            a) In case of damages caused by a grossly negligent or willful
            breach of these Terms by PENTATONIC or its agents;
          </p>
          <p>
            b) In case of damages caused by a breach of an essential obligation
            under these Terms in a manner that puts the fulfillment of the
            purpose of these Terms at risk;
          </p>
          <p>
            c) In case of bodily injury, death, or damages to health, caused by
            a negligent breach by PENTATONIC or its agents;
          </p>
          <p>d) In case of fraudulent concealment of defects;</p>
          <p>
            e) In case of a liability according to applicable product liability
            laws.
          </p>
          <p>
            In addition, the following specific limitations apply to website use
            and digital services:
          </p>
          <p>PENTATONIC is not liable for:</p>
          <p>
            a) Inaccuracies, errors, or omissions in website content or search
            results;
          </p>
          <p>
            b) Decisions made or actions taken by users in reliance on website
            information or search results;
          </p>
          <p>
            c) Indirect or consequential damages arising from use of the website
            or digital services;
          </p>
          <p>
            d) Business losses, including loss of profits, business opportunity,
            or data.
          </p>
          <p>
            These limitations do not apply to liability that cannot be excluded
            under applicable law, including liability for death or personal
            injury caused by negligence.
          </p>
          <h3>
            <strong>8. External Links</strong>
          </h3>

          <p>
            The PENTATONIC website may contain links to third-party websites or
            services that are not owned or controlled by PENTATONIC. PENTATONIC
            has no control over, and assumes no responsibility for, the content,
            privacy policies, or practices of any third-party websites or
            services. Users further acknowledge and agree that PENTATONIC shall
            not be responsible or liable, directly or indirectly, for any damage
            or loss caused or alleged to be caused by or in connection with the
            use of or reliance on any such content, goods, or services available
            on or through any such websites or services.
          </p>
          <h3>
            <strong>9. Governing Law and Jurisdiction</strong>
          </h3>

          <p>
            These Terms and Conditions are governed by German law. For consumers
            domiciled in a foreign country, mandatory provisions applicable in
            that country remain unaffected.
          </p>
          <p>
            For disputes related to the use of our website and digital services,
            users agree to attempt to resolve the matter through informal
            negotiations before pursuing formal legal proceedings, except where
            interim relief is sought.
          </p>
          <p>
            In the event that the user is a merchant (according to the German
            commercial code – Handelsgesetzbuch) or a public legal entity, the
            place of jurisdiction for all disputes in connection with the use of
            the PENTATONIC website is, at the option of PENTATONIC, either
            Berlin-Mitte or the seat of the user. As to lawsuits against
            PENTATONIC, Berlin-Mitte is the exclusive place of jurisdiction.
            Mandatory statutory provisions on exclusive places of jurisdiction
            remain unaffected.
          </p>
          <h3>
            <strong>10. Contact Information</strong>
          </h3>

          <p>PENTATONIC GmbH</p>
          <p>Greifswalderstr. 51</p>
          <p>Regus Business Centre</p>
          <p>10405 Berlin</p>
          <p>Tel: +49 30 3395 6013</p>
          <p>E-Mail: support@pentatonic.com</p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
